import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-bus-preloader',
  templateUrl: './bus-preloader.component.html',
  styleUrls: ['./bus-preloader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BusPreloaderComponent { }
